<script setup lang="ts">
import { computed } from 'vue';
import { useViewQuoteStore } from '@/store/ViewQuoteStore';

const viewQuoteStore = useViewQuoteStore();
const url = computed(() => viewQuoteStore.selectUrlQuote);
</script>
<template>
  <embed type="text/html" :src="url" class="pdf-size w-full" />
</template>
<style lang="scss" scoped>
.pdf-size {
  width: 800px;
  height: 90vh;
}
</style>
